import { render, staticRenderFns } from "./NumberControl.vue?vue&type=template&id=1d00f4d2&scoped=true&"
import script from "./NumberControl.vue?vue&type=script&lang=ts&"
export * from "./NumberControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d00f4d2",
  null
  
)

export default component.exports